import type {AppPayload} from '@github-ui/issues-shared/app-payload'
/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload -- the SSR payload is the only first-render source of saved views; the UI Service route-data path does not cover these pages yet. */
import {useAppPayload} from '@github-ui/react-core/use-app-payload'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {useQuery} from '@github-ui/react-query'
import {savedViewsQueryOptions} from '@github-ui/saved-views/queries'
import {canShowCreateAction} from '@github-ui/saved-views/utils/can-show-create-action'

export function useSavedViews({owner, repo, enabled}: {owner: string; repo: string; enabled?: boolean}) {
  const serverViews = useAppPayload<AppPayload>()?.saved_views ?? undefined
  const query = useQuery({...savedViewsQueryOptions({owner, repo, initialData: serverViews}), enabled})
  // eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags -- issue_pinned_views_team_vs_personal uses actor-aware server-side evaluation via PinnedViewsFeature; isFeatureEnabled only knows current_user.
  const teamPersonalEnabled = useFeatureFlag('issue_pinned_views_team_vs_personal')

  return {
    ...query,
    serverViews,
    views: query.data?.savedViews ?? [],
    viewerCanManageViews: query.data?.viewerCanManageViews ?? false,
    showCreateAction: canShowCreateAction({savedViews: query.data, teamPersonalEnabled}),
  }
}
